import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import './index.css';

const container = document.getElementById('root');
ReactDOM.render(<Routes />, container);
